document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.main-highlights .swiper-container')
  if (!el) return

  const swiper = new Swiper(el, {
    loop: false,
    speed: 600,
    slidesPerView: 1.4,
    spaceBetween: 8,
    centeredSlides: false,
    navigation: {
      nextEl: '.main-highlights__controller-next',
      prevEl: '.main-highlights__controller-prev',
    },
    a1ly: {
      prevSlideMessage: 'Go to previous slide',
      nextSlideMessage: 'Go to next slide',
      paginationBulletMessage: 'Go to slide {{index}}',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
    },
  })
})
